// Copyright (c) 2016 Deere & Company

import AllPartRequests from '../../part-requests/all-parts-requests/state-connector';

export default {
    component: AllPartRequests,
    name: 'ALL_PART_REQUESTS',
    path: 'all'
};



// WEBPACK FOOTER //
// ./src/routes/part-requests/all-part-requests.js